import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Col, Row, Card, Button } from 'react-bootstrap';
import { DataTable } from '../widgets/DataTable';
import { CardContainer } from '../widgets/CardContainer';
import { SubNav } from '../layout/submenu';
import { getGeoFieldList, getWorkedAcres, updateFieldWorkStatus } from '../../actions/geo';
import { ButtonGroupToggle, Heading5 } from '../widgets';
import { searchWord } from '../../helpers/common';
import { Unit } from '../../helpers/unit';
import LoadingStyle from '../dashboard/Common/LoadingStyle';
import { Modal } from '../widgets';
import { ACTIVE_WORK_STATUS, COMPLETED_WORK_STATUS, HARVESTING_WORK_TYPE_ID, NOT_APPLICABLE } from '../../constants';
import "../../../assets/scss/geoshape.scss";



const WorkedFieldList = () => {
    const dispatch = useDispatch();
    const { farmId } = useParams();

    const [searchText, setSearchText] = useState("");
    const [active, setActive] = useState(false);
    const [complete, setComplete] = useState(false);
    const [fieldWorkStatus, setFieldWorkStatus] = useState({
        workstatus: null,
        farmUuid: null,
        workTypeId: null,
        geoRegionShapeUuid: null,
        geoShapeUuid: null
    });
    const [updatingShapeId, setUpdatingShapeId] = useState([]);
    const [currentFieldName, setCurrentFieldName] = useState(null);
    const [selectedViewType, setSelectedViewType] = useState(1);
    const [enableBulkEdit, setEnableBulkEdit] = useState(false);
    const [bulkEditFieldList, setBulkEditFieldList] = useState({});
    const [selectedFieldIds, setSelectedFieldIds] = useState([]);

    const geoFieldListById = useSelector(state => state.geo.fieldListById.payload);
    const geoFieldList = Object.entries(geoFieldListById).map(([_, item]) => item);
    const isRequestingFieldList = useSelector(state => state.geo.fieldListById.isRequesting);
    const workedAcres = useSelector(state => state.geo.workedAcresById.payload);
    const isRequestingWorkedAcres = useSelector(state => state.geo.workedAcresById.isRequesting);
    const settings = useSelector(state => state.user.settings);

    const unit = Unit.getInstance();

    const tabs = [
        { value: 1, label: "All Fields" },
        { value: 2, label: "Active Fields" },
        { value: 3, label: "Completed Fields" }];

    useEffect(() => {
        dispatch(getGeoFieldList(farmId));
        dispatch(getWorkedAcres({ farmId }));
    }, [farmId]);

    const handleSearchBox = (searchText) => {
        setSearchText(searchText);
    }

    const formatStatus = (status) => {
        if (status === 1)
            return <span className="badge badge-pill badge-success badge-sm">Active</span>;
        if (status === 4)
            return <span className="badge badge-pill badge-danger badge-sm">Completed</span>;
        return NOT_APPLICABLE;
    }

    const fieldAction = (props) => {
        const { work_status, farm_uuid, geo_region_shape_uuid, work_type_id, geo_shape_uuid, fieldName } = props;
        if (work_status === 1)
            return <Button size="sm"
                variant="danger"
                className="btn-xs"
                onClick={() => {
                    setComplete(!complete);
                    setCurrentFieldName(fieldName);
                    setFieldWorkStatus({
                        ...fieldWorkStatus, workstatus: COMPLETED_WORK_STATUS,
                        farmUuid: farm_uuid,
                        workTypeId: work_type_id,
                        geoRegionShapeUuid: geo_region_shape_uuid,
                        geoShapeUuid: geo_shape_uuid
                    });

                }}>Mark as Completed</Button>
        if (work_status === 4)
            return <Button size="sm"
                variant="success"
                onClick={() => {
                    setActive(!active);
                    setCurrentFieldName(fieldName);
                    setFieldWorkStatus({
                        ...fieldWorkStatus, workstatus: ACTIVE_WORK_STATUS,
                        farmUuid: farm_uuid,
                        workTypeId: work_type_id,
                        geoRegionShapeUuid: geo_region_shape_uuid,
                        geoShapeUuid: geo_shape_uuid
                    });
                }}> Mark as Active</Button>
    }

    const getFilteredList = (isSearchText) => {
        let filteredList = geoFieldList;
        if (isSearchText) {
            const isSearchTextMatched = value => searchWord(value, searchText);
            if (searchText.trim().length > 0) filteredList = filteredList.filter(e => {
                return isSearchTextMatched(e.geo_shape_name) ||
                    isSearchTextMatched(e.regionDetails.geo_region_name) ||
                    isSearchTextMatched(e.regionDetails.customer_name)
            });
        }

        if (selectedViewType === 2) {
            filteredList = filteredList.filter(e => e.lastWorkStatus.work_status === ACTIVE_WORK_STATUS);
        }
        else if (selectedViewType === 3) {
            return filteredList = filteredList.filter(e => e.lastWorkStatus.work_status === COMPLETED_WORK_STATUS);
        }
        return filteredList;
    }

    const handleFieldWorkStatus = () => {
        const params = {
            farm_uuid: farmId,
            work_status: [{
                geo_shape_uuid: fieldWorkStatus.geoShapeUuid,
                geo_region_shape_uuid: fieldWorkStatus.geoRegionShapeUuid,
                work_status: fieldWorkStatus.workstatus,
                work_type_id: fieldWorkStatus.workTypeId,
            }]
        };
        setUpdatingShapeId(fieldWorkStatus.geoShapeUuid);
        dispatch(updateFieldWorkStatus(params, () => {
            setUpdatingShapeId([]);
        }));
    };

    const handleBulkSelect = () => {
        let selectedNewFieldIds = [];
        filteredList.map(e => {
            if (!selectedFieldIds.includes(e.geo_shape_uuid)) selectedNewFieldIds.push(e.geo_shape_uuid);
            return bulkEditFieldList[e.geo_shape_uuid] = {
                geo_shape_uuid: e.geo_shape_uuid,
                geo_region_shape_uuid: e.geo_shape_object_uuid,
                work_type_id: e.lastWorkStatus.work_type_id,
            };
        });
        setBulkEditFieldList(bulkEditFieldList);
        setSelectedFieldIds(selectedNewFieldIds);
    };

    const handleBulkUpdate = (bulkEditFieldList, updatingWorkStatus) => {
        const params = {
            farm_uuid: farmId,
            work_status: Object.keys(bulkEditFieldList).map(e => {
                let currentField = bulkEditFieldList[e];
                currentField["work_status"] = updatingWorkStatus;
                return currentField;
            })
        };
        setUpdatingShapeId(selectedFieldIds);
        dispatch(updateFieldWorkStatus(params, () => {
            setUpdatingShapeId([]);
            setBulkEditFieldList([]);
        }));
    };

    const filteredList = getFilteredList(true);

    return (
        <>
            <CardContainer lg={12} md={12} sm={12} xs={12}>
                <Card className="card-list">
                    <Card.Header>
                        <Card.Title>
                            <Heading5>Field List</Heading5>
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <div className="search-container d-flex">
                                <SubNav.SearchBox placeholder="Search for Region, Shape and Customer name"
                                    value={searchText}
                                    onChange={e => handleSearchBox(e.target.value)}
                                    onClear={() => handleSearchBox("")} />

                                <ButtonGroupToggle
                                    options={tabs}
                                    value={selectedViewType} onSelect={(type) => {
                                        setSelectedViewType(type);
                                        setBulkEditFieldList({});
                                        setSelectedFieldIds([]);
                                        (type !== 1) ? setEnableBulkEdit(true) : setEnableBulkEdit(false)
                                    }}
                                    className="ml-4 mb-3 button-group" />
                            </div>
                            <Col className="text-right">
                                {selectedViewType === 3 && filteredList.length !== 0
                                    ? <Button size="sm"
                                        variant="success"
                                        className="mb-3 ml-5 "
                                        disabled={updatingShapeId.length > 0 || Object.keys(bulkEditFieldList).length === 0}
                                        onClick={() => {
                                            handleBulkUpdate(bulkEditFieldList, ACTIVE_WORK_STATUS);
                                        }}> {updatingShapeId.length > 0 ? "Updating..." : "Mark as Active"}</Button>
                                    : selectedViewType === 2 && filteredList.length !== 0 ?
                                        <Button size="sm"
                                            variant="danger"
                                            className="mb-3 ml-5"
                                            disabled={updatingShapeId.length > 0 || Object.keys(bulkEditFieldList).length === 0}
                                            onClick={() => {
                                                handleBulkUpdate(bulkEditFieldList, COMPLETED_WORK_STATUS);
                                            }
                                            }>{updatingShapeId.length > 0 ? "Updating..." : "Mark as Completed"}</Button> : ""
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} md={12} sm={12}>
                                <DataTable>
                                    <DataTable.Header>
                                        <DataTable.Row>
                                            <DataTable.Cell style={{ width: "40px" }}>#</DataTable.Cell>
                                            <DataTable.Cell>Region Name</DataTable.Cell>
                                            <DataTable.Cell>Shape Name</DataTable.Cell>
                                            <DataTable.Cell>{`Total ${settings.areaShortName}`}</DataTable.Cell>
                                            <DataTable.Cell>{`Total Completed ${settings.areaShortName}`}</DataTable.Cell>
                                            <DataTable.Cell>Status</DataTable.Cell>
                                            {!enableBulkEdit ? <DataTable.Cell style={{ width: "160px" }}>Action</DataTable.Cell>
                                                : <DataTable.Cell width="45px">
                                                    <SubNav.Checkbox
                                                        checked={Object.keys(bulkEditFieldList).length > 0}
                                                        className={`square ${Object.keys(bulkEditFieldList).length === filteredList.length ? "" : "partial"} `}
                                                        onChange={(e) => {
                                                            if (e.target.checked) handleBulkSelect();
                                                            else if (!e.target.checked) {
                                                                setBulkEditFieldList({});
                                                                setSelectedFieldIds([]);
                                                            };
                                                        }
                                                        }
                                                    />
                                                </DataTable.Cell>}
                                        </DataTable.Row>
                                    </DataTable.Header>
                                    <DataTable.Body>
                                        {filteredList.map((e, i) => (
                                            <DataTable.Row className={""} key={i} >
                                                <DataTable.Cell style={{ width: "40px" }}>{i + 1}</DataTable.Cell>
                                                <DataTable.Cell>
                                                    {e.regionDetails.geo_region_name}
                                                    {e.regionDetails.customer_name && e.regionDetails.customer_name.trim().length > 0 && e.regionDetails.customer_name !== 'Unknown' && <span className='text-muted' style={{ whiteSpace: 'nowrap' }}> | {e.regionDetails.customer_name}</span>}
                                                </DataTable.Cell>
                                                <DataTable.Cell>{e.geo_shape_name}</DataTable.Cell>
                                                <DataTable.Cell style={{ width: "260px" }}>{e.regionDetails.totalAcres}</DataTable.Cell>
                                                <DataTable.Cell style={{ width: "260px" }} >{isRequestingWorkedAcres
                                                    ? <LoadingStyle />
                                                    : (workedAcres[e.geo_shape_uuid]
                                                        ? unit.toArea(workedAcres[e.geo_shape_uuid].workedAcres, 2) : 0)
                                                }</DataTable.Cell>
                                                <DataTable.Cell className="text-center" style={{ width: "140px" }}>{formatStatus(e.lastWorkStatus
                                                    ? e.lastWorkStatus.work_status : null)}</DataTable.Cell>
                                                {enableBulkEdit
                                                    ? <DataTable.Cell width="45px">
                                                        <SubNav.Checkbox
                                                            className="square"
                                                            checked={bulkEditFieldList.hasOwnProperty(e.geo_shape_uuid)}
                                                            onChange={(l) => {
                                                                if (l.target.checked) {
                                                                    if (!selectedFieldIds.includes(e.geo_shape_uuid)) setSelectedFieldIds([...selectedFieldIds, e.geo_shape_uuid]);
                                                                    bulkEditFieldList[e.geo_shape_uuid] = {
                                                                        geo_shape_uuid: e.geo_shape_uuid,
                                                                        geo_region_shape_uuid: e.geo_shape_object_uuid,
                                                                        work_type_id: HARVESTING_WORK_TYPE_ID,
                                                                    };

                                                                }
                                                                else if (l.target.checked === false) {
                                                                    const index = selectedFieldIds.indexOf(e.geo_shape_uuid);
                                                                    if (index > -1) {
                                                                        selectedFieldIds.splice(index, 1);
                                                                        setSelectedFieldIds([...selectedFieldIds])
                                                                    };
                                                                    delete bulkEditFieldList[e.geo_shape_uuid];
                                                                }
                                                            }}
                                                        />
                                                    </DataTable.Cell>
                                                    : <DataTable.Cell className="text-center">{
                                                        updatingShapeId.indexOf(e.geo_shape_uuid) !== -1 ? <LoadingStyle />
                                                            : fieldAction(
                                                                {
                                                                    geo_region_shape_uuid: e.geo_shape_object_uuid,
                                                                    geo_shape_uuid: e.geo_shape_uuid,
                                                                    work_status: e.lastWorkStatus ? e.lastWorkStatus.work_status : null,
                                                                    work_type_id: HARVESTING_WORK_TYPE_ID,
                                                                    fieldName: e.geo_shape_name
                                                                }
                                                            )
                                                    }</DataTable.Cell>}
                                            </DataTable.Row>))}
                                    </DataTable.Body>
                                </DataTable>
                                {isRequestingFieldList
                                    ? <DataTable.Loading />
                                    : filteredList.length === 0 && <DataTable.RecordsNotFound />}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </CardContainer>
            <Modal.Confirm
                isOpen={complete}
                onConfirm={handleFieldWorkStatus}
                iconClassName="fa fa-question"
                title={{ content: "Confirmation" }}
                body={<>Are you sure to mark field <b>{currentFieldName}</b> as completed?</>}
                variant="info"
                confirmButton={{ variant: "info" }}
                onHide={() => setComplete(false)}
            />
            <Modal.Confirm
                isOpen={active}
                onConfirm={handleFieldWorkStatus}
                iconClassName="fa fa-question"
                title={{ content: "Confirmation" }}
                body={<>Are you sure to mark field <b>{currentFieldName}</b> as active?</>}
                variant="info"
                confirmButton={{ variant: "info" }}
                onHide={() => setActive(false)}
            />
        </>
    );
};

export default WorkedFieldList;